// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2pQ3O","inner":"Form_inner__1VO2U","range":"Form_range__1APU2","name":"Form_name__1k9j8","actions":"Form_actions__2TZOM"};